import React from "react";
const OfficalRating = ({ rating,inline }) => {
    let items = [];

    for (let i = 0; i < rating; i++) {
        items.push(<svg key={i} width="18" height="18" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.03656 0.866506L8.09243 2.99573C8.23643 3.29212 8.62038 3.57642 8.94438 3.63086L10.8581 3.95145C12.082 4.15712 12.37 5.05236 11.4881 5.9355L10.0003 7.43562C9.74826 7.68966 9.61031 8.17962 9.68825 8.5305L10.1143 10.3875C10.4502 11.8574 9.67625 12.426 8.38643 11.6578L6.59262 10.5871C6.26868 10.3936 5.73474 10.3936 5.40474 10.5871L3.61096 11.6578C2.3271 12.426 1.54719 11.8513 1.88315 10.3875L2.3091 8.5305C2.38709 8.17962 2.24911 7.68966 1.99713 7.43562L0.509303 5.9355C-0.3666 5.05236 -0.0846302 4.15712 1.13923 3.95145L3.05302 3.63086C3.37098 3.57642 3.75494 3.29212 3.89892 2.99573L4.9548 0.866506C5.53074 -0.288835 6.46662 -0.288835 7.03656 0.866506Z" fill="#1a8fd9" />
        </svg>);
    }
    
    return (<div className={`flex flex-row gap-x-1 ${inline ? "" : "mt-[-5px]"}`}>
        {items}
    </div>
    );
};
export default OfficalRating;
